import { render, staticRenderFns } from "./miles-subsidy-forward.vue?vue&type=template&id=897c46f0&scoped=true"
import script from "./miles-subsidy-forward.vue?vue&type=script&lang=js"
export * from "./miles-subsidy-forward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897c46f0",
  null
  
)

export default component.exports